module.exports = __webpack_public_path__ + "static/media/riskQuestion.d4d44414.mp3";